/* video-with-text.js — tap anywhere to play/pause (Shopify-hosted <video>)
   + open cookie preferences from GDPR placeholder. */
(() => {
  if (window.__VideoWithTextInstalled) return;
  window.__VideoWithTextInstalled = true;

  // ---------- Tap-to-play for Shopify-hosted <video> ----------
  function prime(video) {
    try { video.setAttribute('muted',''); } catch(e){}
    video.muted = true;
    try { video.setAttribute('playsinline',''); } catch(e){}
    video.playsInline = true;
    if (video.readyState === 0) { try { video.load(); } catch(e){} }
  }
  function toggle(video) {
    if (!video) return;
    if (video.paused || video.ended) {
      prime(video);
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } else {
      try { video.pause(); } catch(e){}
    }
  }
  // Delegate so it works for all instances / dynamic sections
  document.addEventListener('pointerdown', (ev) => {
    const btn = ev.target.closest('[data-tap-toggle]');
    if (!btn) return;
    const root = btn.closest('[data-video-with-text]');
    if (!root) return;
    const video = root.querySelector('video');
    if (!video) return;
    ev.preventDefault();
    ev.stopPropagation();
    toggle(video);
  }, { capture: true });

  // ---------- Open cookie preferences from placeholder ----------
  function openCookiePrefs() {
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.showPreferencesConsent === 'function') {
        Shopify.customerPrivacy.showPreferencesConsent();
        return;
      }
    } catch(e){}
    try {
      if (window.Shopify && Shopify.ConsentTracking && typeof Shopify.ConsentTracking.showPreferences === 'function') {
        Shopify.ConsentTracking.showPreferences();
        return;
      }
    } catch(e){}
    // Fire common custom events used by consent apps (fallback)
    try { window.dispatchEvent(new Event('cookie:preferences:open')); } catch(e){}
    try { document.dispatchEvent(new Event('cookieConsentOpen')); } catch(e){}
  }

  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest('[data-open-cookie-preferences]');
    if (!btn) return;
    ev.preventDefault();
    openCookiePrefs();
  }, { capture: true });
})();
